// removed by extract-text-webpack-plugin
module.exports = {"watermarkBackground":"_1a5vPEnTne-6R-f4ofTpcl","watermarkBackgroundMuted":"wTOss0zzGO7JWa2nFHmR-","header":"pJsstSepP-ig4Leao_6QD","page":"_1LZ1gPd2EoJqg8R9o7MBFL","content":"_3yj8l4Bl5PJo_z3jmK8Ot5","buttons":"_3Cb5B3E98XnJWEHhzdpVhh","terms":"_2fh6BUD3gOcTAhKp3Ecom8","marker":"_3_7q4wXhd8m-peAfZKJyTT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserConsent/UserConsent.scss
// module id = 1343
// module chunks = 1